import { DOCUMENT } from "@angular/common";
import { inject, Injectable, PLATFORM_ID } from "@angular/core";
import { isPlatformBrowser } from "@angular/common";

@Injectable({ providedIn: "root" })
export class GoogleMapsLoaderService {
  private apiKey = "AIzaSyAdYgltUfkezDflzfIkFo6vHtCWlBg-1fA";
  private loadingPromise: Promise<void> | null = null;
  private document = inject(DOCUMENT);
  private platformId = inject(PLATFORM_ID);

  load(): Promise<void> {
    if (!isPlatformBrowser(this.platformId)) {
      return Promise.resolve();
    }

    if (this.loadingPromise) return this.loadingPromise;

    this.loadingPromise = new Promise((resolve, reject) => {
      if ((window as any).google && (window as any).google.maps) {
        resolve();
        return;
      }

      const script = this.document.createElement("script");
      script.src = `https://maps.googleapis.com/maps/api/js?key=${this.apiKey}&libraries=places`;
      script.async = true;
      script.defer = true;
      script.onload = () => resolve();
      script.onerror = (err) => reject(err);

      this.document.head.appendChild(script);
    });

    return this.loadingPromise;
  }
}
